var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 31,
    fill: "#404040"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Doctor flow"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-9130 -7509C-9130 -7510.1 -9129.1 -7511 -9128 -7511H11865C11866.1 -7511 11867 -7510.1 11867 -7509V6695C11867 6696.1 11866.1 6697 11865 6697H-9128C-9129.1 6697 -9130 6696.1 -9130 6695V-7509Z",
    fill: "#807E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9128 -7510H11865V-7512H-9128V-7510ZM11866 -7509V6695H11868V-7509H11866ZM11865 6696H-9128V6698H11865V6696ZM-9129 6695V-7509H-9131V6695H-9129ZM-9128 6696C-9128.55 6696 -9129 6695.55 -9129 6695H-9131C-9131 6696.66 -9129.66 6698 -9128 6698V6696ZM11866 6695C11866 6695.55 11865.6 6696 11865 6696V6698C11866.7 6698 11868 6696.66 11868 6695H11866ZM11865 -7510C11865.6 -7510 11866 -7509.55 11866 -7509H11868C11868 -7510.66 11866.7 -7512 11865 -7512V-7510ZM-9128 -7512C-9129.66 -7512 -9131 -7510.66 -9131 -7509H-9129C-9129 -7509.55 -9128.55 -7510 -9128 -7510V-7512Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Prescription / Lab test"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1536,
    height: 2007,
    transform: "translate(-1360 -1320)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "BLUE BACKGROUND ",
    x: -1360,
    y: -1321,
    width: 1536,
    height: 2008,
    fill: "#E1F3F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 625481"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 625209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 18227",
    d: "M-1296 -270H100C106.627 -270 112 -264.627 112 -258V380C112 386.627 106.627 392 100 392H-1284C-1290.63 392 -1296 386.627 -1296 380V-270Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 625205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 625191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 294019"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 625363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 16609"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 15559"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 258",
    d: "M29.625 15.25C29.625 23.3272 23.0772 29.875 15 29.875C6.92284 29.875 0.375 23.3272 0.375 15.25C0.375 7.17284 6.92284 0.625 15 0.625C23.0772 0.625 29.625 7.17284 29.625 15.25Z",
    stroke: "#F00001",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.4286 12.9167V20.6944H11.5714V12.9167H18.4286ZM17.1429 8.25H12.8571L12 9.02778H9V10.5833H21V9.02778H18L17.1429 8.25ZM20.1429 11.3611H9.85714V20.6944C9.85714 21.55 10.6286 22.25 11.5714 22.25H18.4286C19.3714 22.25 20.1429 21.55 20.1429 20.6944V11.3611Z",
    fill: "#F00001"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.27778f846ed48596539327681d4a7048.svg";
export { ForwardRef as ReactComponent };